import { createAsyncThunk } from "@reduxjs/toolkit";
import { CreateWorkflowRole, UpdateWorkflowRole, WorkflowRole } from "./workflowTypes";
import { AppThunkAPIType } from "../../../../app/appTypes";
import { deleteWithAuth, getWithAuth, postWithAuth, putWithAuth } from "../../../../http";

export const loadWorkflowRoles = createAsyncThunk<WorkflowRole[], void, AppThunkAPIType>(
    "workflow-roles/load-all",
    async (_, { dispatch, rejectWithValue }) => {
        const result = await dispatch(getWithAuth({ url: `api/workflow-roles` }));
        const { payload } = result;

        if (getWithAuth.fulfilled.match(result)) {
            return payload as WorkflowRole[];
        } else {
            return rejectWithValue(payload ?? { kind: "unknown" });
        }
    }
);

export const createWorkflowRole = createAsyncThunk<WorkflowRole, CreateWorkflowRole, AppThunkAPIType>(
    "workflow-roles/create",
    async (data, { dispatch, rejectWithValue }) => {
        const result = await dispatch(
            postWithAuth({ url: `api/workflow-roles`, payload: data })
        );

        if (postWithAuth.fulfilled.match(result)) {
            return result.payload as WorkflowRole;
        } else {
            return rejectWithValue(result.payload ?? { kind: "unknown" });
        }
    }
);

export const updateWorkflowRole = createAsyncThunk<WorkflowRole, { id: string; data: UpdateWorkflowRole }, AppThunkAPIType>(
    "workflow-roles/update",
    async ({ id, data }, { dispatch, rejectWithValue }) => {
        const result = await dispatch(
            putWithAuth({ url: `api/workflow-roles/${id}`, payload: data })
        );

        if (putWithAuth.fulfilled.match(result)) {
            return result.payload as WorkflowRole;
        } else {
            return rejectWithValue(result.payload ?? { kind: "unknown" });
        }
    }
);

export const deleteWorkflowRole = createAsyncThunk<string, string, AppThunkAPIType>(
    "workflow-roles/delete",
    async (id, { dispatch, rejectWithValue }) => {
        const result = await dispatch(
            deleteWithAuth({ url: `api/workflow-roles/${id}` })
        );

        if (deleteWithAuth.fulfilled.match(result)) {
            return id;
        } else {
            return rejectWithValue(result.payload ?? { kind: "unknown" });
        }
    }
);
